export const ERROR_MESSAGE =
  'Sorry, an error has occurred and your request could not be processed. Please try again later.'

export const CATEGORIES_ORDER = [
  'Small Cars',
  'Family Cars',
  'SUV & 4x4',
  'Sports',
  'Commercial',
]

export const FUEL_ORDER = [
  'Hybrid',
  'Plug-in Hybrid',
  'All-Electric',
  'Hydrogen Fuel Cell',
  'Petrol',
  'Diesel',
]

export const TIMES = [
  {
    label: '9:00',
    value: '9:00',
  },
  {
    label: '10:00',
    value: '10:00',
  },
  {
    label: '11:00',
    value: '11:00',
  },
  {
    label: '12:00',
    value: '12:00',
  },
  {
    label: '13:00',
    value: '13:00',
  },
  {
    label: '14:00',
    value: '14:00',
  },
  {
    label: '15:00',
    value: '15:00',
  },
  {
    label: '16:00',
    value: '16:00',
  },
]

export const TITLES = [
  {
    label: 'Mr',
    value: 'Mr',
  },
  {
    label: 'Mrs',
    value: 'Mrs',
  },
  {
    label: 'Miss',
    value: 'Miss',
  },
  {
    label: 'Ms',
    value: 'Ms',
  },
  {
    label: 'Mx',
    value: 'Mx',
  },
  {
    label: 'Doctor',
    value: 'Doctor',
  },
  {
    label: 'Professor',
    value: 'Professor',
  },
  {
    label: 'Reverend',
    value: 'Reverend',
  },
]

export const FLEET_SIZE = [
  {
    label: ' 0 - 25',
    value: '0 - 25',
  },
  {
    label: '25 - 250',
    value: '25 - 250',
  },
  {
    label: '250+',
    value: '250+',
  },
]

export const TYPE_OF_ENQUIRIES_TOYOTA = [
  {
    label: 'New vehicle',
    value: 'new_car',
  },
  {
    label: 'Used vehicle',
    value: 'used_car',
  },
  {
    label: 'Motability',
    value: 'motability',
  },
  {
    label: 'Business Fleet Enquiry',
    value: 'fleet_business',
  },
  {
    label: 'Servicing and MOT',
    value: 'servicing',
  },
  {
    label: 'Parts And accessories',
    value: 'parts',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Selling my Toyota',
    value: 'selling',
  },
  {
    label: 'Something else',
    value: 'notlisted_new',
  },
]

export const TYPE_OF_ENQUIRIES_TOYOTA_VALUES = {
  new_car: {
    type: 'NV',
    type_of_enquiry: 'A new Toyota',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale',
    pvt_company_car: 'I',
  },
  used_car: {
    type: 'UV',
    type_of_enquiry: 'A used vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Used Vehicle Sale',
    pvt_company_car: 'I',
  },
  motability: {
    type: 'MA',
    type_of_enquiry: 'Motability enquiry',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Motability',
    pvt_company_car: 'I',
  },
  fleet_business: {
    type: 'NF',
    type_of_enquiry: 'A new company vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale - Fleet',
    pvt_company_car: 'B',
  },
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Servicing and MOT',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'New parts or accessories',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Booking my vehicle in for a repair',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
  selling: {
    type: 'ST',
    type_of_enquiry: 'Selling my current Toyota',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Selling my current Toyota',
    pvt_company_car: 'I',
  },
  notlisted_new: {
    type: 'CU',
    type_of_enquiry: 'Something not listed above, related to a new vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'General Enquiry',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_LEXUS = [
  {
    label: 'New Car',
    value: 'new_car',
  },
  {
    label: 'Used Car',
    value: 'used_car',
  },
  {
    label: 'Motability',
    value: 'motability',
  },
  {
    label: 'Car Service & MOT',
    value: 'servicing',
  },
  {
    label: 'My Vehicle',
    value: 'notlisted_current',
  },
  {
    label: 'Parts & Accessories',
    value: 'parts',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Fleet Business',
    value: 'fleet_business',
  },
  {
    label: 'Other Sales Enquiries',
    value: 'notlisted_new',
  },
]

export const TYPE_OF_ENQUIRIES_LEXUS_VALUES = {
  new_car: {
    type: 'NV',
    type_of_enquiry: 'New Car',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale',
    pvt_company_car: 'I',
  },
  used_car: {
    type: 'UV',
    type_of_enquiry: 'Used Car',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Used Vehicle Sale',
    pvt_company_car: 'I',
  },
  motability: {
    type: 'MA',
    type_of_enquiry: 'Motability enquiry',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Motability',
    pvt_company_car: 'I',
  },
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Car Service & MOT',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  notlisted_current: {
    type: 'AS',
    type_of_enquiry: 'My Vehicle',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'After Sales Enquiry',
    pvt_company_car: 'I',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'Parts & Accessories',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Repair',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
  fleet_business: {
    type: 'NF',
    type_of_enquiry: 'Fleet Business',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale - Fleet',
    pvt_company_car: 'B',
  },
  notlisted_new: {
    type: 'CU',
    type_of_enquiry: 'Other Sales Enquiries',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'General Enquiry',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_OTSO = [
  {
    label: 'Servicing and MOT',
    value: 'servicing',
  },
  {
    label: 'Servicing and MOT for my company vehicle',
    value: 'fleet_servicing',
  },

  {
    label: 'New parts or accessories',
    value: 'parts',
  },
  {
    label: 'Booking my vehicle in for a repair',
    value: 'repair',
  },
  {
    label: 'Something not listed above, related to my current vehicle',
    value: 'notlisted_current',
  },
]

export const TYPE_OF_ENQUIRIES_OTSO_VALUES = {
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Servicing and MOT',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  fleet_servicing: {
    type: 'SF',
    type_of_enquiry: 'Servicing and MOT for my company vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry - Fleet',
    pvt_company_car: 'B',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'New parts or accessories',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Booking my vehicle in for a repair',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
  notlisted_current: {
    type: 'AS',
    type_of_enquiry:
      'Something not listed above, related to my current vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'After Sales Enquiry',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_OLSO = [
  {
    label: 'Car Service & MOT',
    value: 'servicing',
  },
  {
    label: 'My Vehicle',
    value: 'notlisted_current',
  },
  {
    label: 'Parts & Accessories',
    value: 'parts',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
]

export const TYPE_OF_ENQUIRIES_OLSO_VALUES = {
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Car Service & MOT',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  notlisted_current: {
    type: 'AS',
    type_of_enquiry: 'My Vehicle',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'After Sales Enquiry',
    pvt_company_car: 'I',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'Parts & Accessories',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Repair',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_CALLBACK = [
  {
    label: 'New Car sales',
    value: 'New Car sales',
  },
  {
    label: 'Used Car sales',
    value: 'Used Car sales',
  },
  {
    label: 'Service',
    value: 'Service',
  },
  {
    label: 'Parts and Accessories',
    value: 'Parts and Accessories',
  },
  {
    label: 'Finance offers',
    value: 'Finance offers',
  },
  {
    label: 'Other',
    value: 'Other',
  },
]

export const TYPE_OF_ENQUIRIES_GENERAL = [
  {
    label: 'Enquiry about my vehicle',
    value: 'general_enquiry:1',
  },
  {
    label: 'Enquiry about my Servicing, Parts or Accessories',
    value: 'general_enquiry:2',
  },
  {
    label: 'Help with my Toyota™',
    value: 'general_enquiry:3',
  },
  {
    label: 'Other enquiry',
    value: 'general_enquiry:4',
  },
]

export const TYPE_OF_ENQUIRIES_ROADSIDE = [
  {
    label: 'General Enquiry about Toyota Roadside Assistance (Club Toyota)',
    value: 'TRA:1',
  },
  {
    label:
      'Enquiry about renewal or cancellation of Toyota Roadside Assistance',
    value: 'TRA:2',
  },
]

export const TYPE_OF_ENQUIRIES_MULTIMEDIA = [
  {
    label: 'Account',
    value: 'multimedia:1',
  },
  {
    label: 'Service & Maintenance',
    value: 'multimedia:2',
  },
  {
    label: 'Connected Services',
    value: 'multimedia:3',
  },
  {
    label: 'Connected Insurance',
    value: 'multimedia:4',
  },
  {
    label: 'Remote Services',
    value: 'multimedia:5',
  },
  {
    label: 'Standard Services',
    value: 'multimedia:6',
  },
  {
    label: 'Charging Network',
    value: 'multimedia:7',
  },
  {
    label: 'Digital Key',
    value: 'multimedia:8',
  },
  {
    label: 'Home Charge',
    value: 'multimedia:9',
  },
  {
    label: 'Multimedia',
    value: 'multimedia:10',
  },
  {
    label: 'Subscriptions',
    value: 'multimedia:11',
  },
  {
    label: 'Remote Climate',
    value: 'multimedia:12',
  },
]

export const TYPE_OF_ENQUIRIES_FINANCE = [
  {
    label: 'Arrange Collection of My Vehicle',
    value: 'Arrange Collection of My Vehicle',
  },
  {
    label: 'Settlement Request',
    value: 'Settlement Request',
  },
  {
    label: 'Invoice Enquiry',
    value: 'Invoice Enquiry',
  },
  {
    label: 'Request Copy of Your Finance Agreement',
    value: 'Request Copy of Your Finance Agreement',
  },
  {
    label: 'Difficulty Paying',
    value: 'Difficulty Paying',
  },
  {
    label: 'Address and Contact Details Change',
    value: 'Address and Contact Details Change',
  },
  {
    label: 'Bank Details Change',
    value: 'Bank Details Change',
  },
  {
    label: 'Name Change',
    value: 'Name Change',
  },
  {
    label: 'Re-finance Enquiry',
    value: 'Re-finance Enquiry',
  },
  {
    label: 'Family Bereavement',
    value: 'Family Bereavement',
  },
  {
    label: 'Complaint',
    value: 'Complaint',
  },
  {
    label: 'Payment Protection Insurance (PPI)',
    value: 'Payment Protection Insurance (PPI)',
  },
  {
    label: 'General Enquiry',
    value: 'General Enquiry',
  },
]

export const TYPE_OF_ENQUIRIES_CANS = [
  {
    label: 'Sales General Enquiry',
    value: 'Sales General Enquiry',
  },
  {
    label: 'Aftersales General Enquiry',
    value: 'Aftersales General Enquiry',
  },
  {
    label: 'New Vehicle Enquiry',
    value: 'New Vehicle Enquiry',
  },
  {
    label: 'Used Vehicle Enquiry',
    value: 'Used Vehicle Enquiry',
  },
  {
    label: 'Finance/Leasing',
    value: 'Finance/Leasing',
  },
  {
    label: 'Fleet/Business Enquiry',
    value: 'Fleet/Business Enquiry',
  },
  {
    label: 'Part Exchange',
    value: 'Part Exchange',
  },
  {
    label: 'Service & MOT',
    value: 'Service & MOT',
  },
  {
    label: 'Parts & Accessories',
    value: 'Parts & Accessories',
  },
  {
    label: 'Repair',
    value: 'Repair',
  },
]

export const MODEL_LIST_CANS = [
  {
    label: 'AYGO',
    value: 'AYGO',
  },
  {
    label: 'All New Yaris',
    value: 'All New Yaris',
  },
  {
    label: 'GR Yaris',
    value: 'GR Yaris',
  },
  {
    label: 'Corolla',
    value: 'Corolla',
  },
  {
    label: 'Corolla Touring Sports',
    value: 'Corolla Touring Sports',
  },
  {
    label: 'Corolla Saloon',
    value: 'Corolla Saloon',
  },
  {
    label: 'Camry',
    value: 'Camry',
  },
  {
    label: 'Toyota C-HR',
    value: 'Toyota C-HR',
  },
  {
    label: 'RAV4',
    value: 'RAV4',
  },
  {
    label: 'Toyota GR Supra',
    value: 'Toyota GR Supra',
  },
  {
    label: 'Prius',
    value: 'Prius',
  },
  {
    label: 'Prius Plug-in',
    value: 'Prius Plug-in',
  },
  {
    label: 'Land Cruiser',
    value: 'Land Cruiser',
  },
  {
    label: 'New Hilux',
    value: 'New Hilux',
  },
  {
    label: 'All New Highlander',
    value: 'All New Highlander',
  },
  {
    label: 'PROACE',
    value: 'PROACE',
  },
  {
    label: 'New PROACE City',
    value: 'New PROACE City',
  },
  {
    label: 'PROACE VERSO',
    value: 'PROACE VERSO',
  },
]

export const LEXUS_GRADE_LBX = [
  {
    label: 'Urban',
    value: 'Urban',
  },
  {
    label: 'Premium',
    value: 'Premium',
  },
  {
    label: 'Premium Plus',
    value: 'Premium Plus',
  },
  {
    label: 'Premium Plus Design',
    value: 'Premium Plus Design',
  },
  {
    label: 'Takumi',
    value: 'Takumi',
  },
  {
    label: 'Takumi Design',
    value: 'Takumi Design',
  },
  {
    label: 'Original Edition',
    value: 'Original Edition',
  },
]

export const LEXUS_URBAN_LBX = [
  {
    label: 'Sonic White',
    value: 'Sonic White',
  },
  {
    label: 'Silver Metallic',
    value: 'Silver Metallic',
  },
  {
    label: 'Cement Grey',
    value: 'Cement Grey',
  },
  {
    label: 'Sonic Grey',
    value: 'Sonic Grey',
  },
  {
    label: 'Metallic Red',
    value: 'Metallic Red',
  },
  {
    label: 'Solid Yellow',
    value: 'Solid Yellow',
  },
  {
    label: 'Metallic Blue',
    value: 'Metallic Blue',
  },
  {
    label: 'Eclipse Black',
    value: 'Eclipse Black',
  },
]

export const LEXUS_PREM_LBX = [
  {
    label: 'Sonic White',
    value: 'Sonic White',
  },
  {
    label: 'Silver Metallic',
    value: 'Silver Metallic',
  },
  {
    label: 'Cement Grey',
    value: 'Cement Grey',
  },
  {
    label: 'Sonic Grey',
    value: 'Sonic Grey',
  },
  {
    label: 'Metallic Red',
    value: 'Metallic Red',
  },
  {
    label: 'Solid Yellow',
    value: 'Solid Yellow',
  },
  {
    label: 'Metallic Blue',
    value: 'Metallic Blue',
  },
  {
    label: 'Eclipse Black',
    value: 'Eclipse Black',
  },
]

export const LEXUS_PREM_PLUS_LBX = [
  {
    label: 'Sonic White',
    value: 'Sonic White',
  },
  {
    label: 'Silver Metallic',
    value: 'Silver Metallic',
  },
  {
    label: 'Cement Grey',
    value: 'Cement Grey',
  },
  {
    label: 'Sonic Grey',
    value: 'Sonic Grey',
  },
  {
    label: 'Metallic Red',
    value: 'Metallic Red',
  },
  {
    label: 'Solid Yellow',
    value: 'Solid Yellow',
  },
  {
    label: 'Metallic Blue',
    value: 'Metallic Blue',
  },
  {
    label: 'Eclipse Black',
    value: 'Eclipse Black',
  },
]

export const LEXUS_PREM_PLUS_DESIGN_LBX = [
  {
    label: 'Sonic White Bi-tone',
    value: 'Sonic White Bi-tone',
  },
  {
    label: 'Silver Metallic Bi-tone',
    value: 'Silver Metallic Bi-tone',
  },
  {
    label: 'Cement Grey Bi-tone',
    value: 'Cement Grey Bi-tone',
  },
  {
    label: 'Sonic Grey Bi-tone',
    value: 'Sonic Grey Bi-tone',
  },
  {
    label: 'Ruby Red Bi-tone',
    value: 'Ruby Red Bi-tone',
  },
  {
    label: 'Solid Yellow Bi-tone',
    value: 'Solid Yellow Bi-tone',
  },
  {
    label: 'Metallic Blue Bi-tone',
    value: 'Metallic Blue Bi-tone',
  },
]

export const LEXUS_TAKUMI_LBX = [
  {
    label: 'Sonic White',
    value: 'Sonic White',
  },
  {
    label: 'Silver Metallic',
    value: 'Silver Metallic',
  },
  {
    label: 'Cement Grey',
    value: 'Cement Grey',
  },
  {
    label: 'Sonic Grey',
    value: 'Sonic Grey',
  },
  {
    label: 'Metallic Red',
    value: 'Metallic Red',
  },
  {
    label: 'Solid Yellow',
    value: 'Solid Yellow',
  },
  {
    label: 'Metallic Blue',
    value: 'Metallic Blue',
  },
  {
    label: 'Eclipse Black',
    value: 'Eclipse Black',
  },
]

export const LEXUS_TAKUMI_DESIGN_LBX = [
  {
    label: 'Sonic White Bi-tone',
    value: 'Sonic White Bi-tone',
  },
  {
    label: 'Silver Metallic Bi-tone',
    value: 'Silver Metallic Bi-tone',
  },
  {
    label: 'Cement Grey Bi-tone',
    value: 'Cement Grey Bi-tone',
  },
  {
    label: 'Sonic Grey Bi-tone',
    value: 'Sonic Grey Bi-tone',
  },
  {
    label: 'Ruby Red Bi-tone',
    value: 'Ruby Red Bi-tone',
  },
  {
    label: 'Solid Yellow Bi-tone',
    value: 'Solid Yellow Bi-tone',
  },
  {
    label: 'Metallic Blue Bi-tone',
    value: 'Metallic Blue Bi-tone',
  },
]

export const LEXUS_ORIGINAL_LBX = [
  {
    label: 'Sonic Copper Bi-Tone',
    value: 'Sonic Copper Bi-Tone',
  },
]
